import { VenueNotification } from '../../graphql/API';
import { NotificationMetadata, NotificationMetadataScreen, parseNotificationMetadata } from './metadata';

export const mapNotificationToRoute = (
  notification: Pick<VenueNotification, 'metadata'>,
): string | null => {
  const meta = parseNotificationMetadata(notification.metadata);
  return mapMetadataToRoute(meta);
};

export const mapMetadataToRoute = (meta: NotificationMetadata): string | null => {
  switch (meta.screen) {
    case NotificationMetadataScreen.accessRequests:
      return '/access-requests';

    case NotificationMetadataScreen.venueContent:
      return meta.reservationID ? `/content/${meta.reservationID}` : '/content';

    case NotificationMetadataScreen.content:
      return '/content';

    case NotificationMetadataScreen.collabDetails:
      if (meta.inviteID) return `/collabs?inviteId=${meta.inviteID}`;
      if (meta.offerID) {
        return meta.type === 'product'
          ? `/products/${meta.offerID}`
          : `/offers/${meta.offerID}`;
      }
      return '/collabs';

    case NotificationMetadataScreen.createOffer:
      return '/offers/create';

    case NotificationMetadataScreen.venueBalance:
    case NotificationMetadataScreen.transaction:
      return '/balance';

    case NotificationMetadataScreen.brandUpgradePlan:
      return '/plans';

    case NotificationMetadataScreen.profile:
      return '/profile';

    case NotificationMetadataScreen.home:
      return '/';

    case NotificationMetadataScreen.noshow:
    case NotificationMetadataScreen.penalty:
    case NotificationMetadataScreen.penalties:
      return meta.reservationID ? `/reservations/${meta.reservationID}` : '/reservations';

    case NotificationMetadataScreen.rate:
      return meta.reservationID ? `/reservations/${meta.reservationID}?rate=1` : '/reservations';

    case NotificationMetadataScreen.suspension:
      return '/profile';

    case NotificationMetadataScreen.update:
      return '/notifications';

    // Consumer-only screens — no web equivalent, just mark-as-read.
    case NotificationMetadataScreen.credits:
    case NotificationMetadataScreen.points:
    case NotificationMetadataScreen.explore:
    case NotificationMetadataScreen.referVenue:
    default:
      return null;
  }
};
